import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import cookie from 'react-cookies';

export const checkTypeApi = createApi({
  reducerPath: 'checkTypeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URl}/check_types`,
    prepareHeaders: headers => {
      headers.set('Authorization', `Bearer ${cookie.load('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    getCheckTypes: builder.query({
      query: () => '/',
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const { useGetCheckTypesQuery } = checkTypeApi;
